import { render, staticRenderFns } from "./Search-Products.vue?vue&type=template&id=5d79396e&scoped=true&"
import script from "./Search-Products.vue?vue&type=script&lang=js&"
export * from "./Search-Products.vue?vue&type=script&lang=js&"
import style0 from "./Search-Products.vue?vue&type=style&index=0&id=5d79396e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d79396e",
  null
  
)

export default component.exports